const DOMAINS = [
    'LANG',
    'AI_PRINT_CATEGORIA',
    'AI_PRINT_ENGINE',
    'AI_PRINT_LINGUA'
];


export default DOMAINS;